import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_DOMAIN = 'FETCH_DOMAIN'
const FETCH_DOMAINS = 'FETCH_DOMAINS'

export const getDomainApi = apiCall(
  FETCH_DOMAIN,
  ({ siteId, domainId }: { siteId: string; domainId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/domains/${domainId}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getDomainsApi = apiCall(
  FETCH_DOMAINS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/domains`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
